// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.major-services-container {
  text-align: center;
  background-color: #3fa9c3;
  color: white;
  padding: 20px;
}
.major-services-container h2 {
  color: white;
  font-size: 30px;
}
.major-services {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.major-services-section {
  width: 45%;
}

.major-services-section h3 {
  padding-bottom: 10px;
  font-size: 30px;
  margin-left: -75%;
}

.major-services-section ul {
  list-style-type: disc;
  padding-left: 20px;
  text-align: left;
  font-size: 20px;
}

.major-services-section li {
  margin: 5px 0;
}

@media (max-width: 768px) {
  .major-services {
    flex-direction: column;
    align-items: center;
  }

  .major-services-section {
    width: 90%;
    margin-bottom: 20px;
  }

  .major-services-section h3 {
    margin-left: 0;
    text-align: center;
  }

  .major-services-section ul {
    padding-left: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MajorServices/MajorServices.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".major-services-container {\n  text-align: center;\n  background-color: #3fa9c3;\n  color: white;\n  padding: 20px;\n}\n.major-services-container h2 {\n  color: white;\n  font-size: 30px;\n}\n.major-services {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 20px;\n}\n\n.major-services-section {\n  width: 45%;\n}\n\n.major-services-section h3 {\n  padding-bottom: 10px;\n  font-size: 30px;\n  margin-left: -75%;\n}\n\n.major-services-section ul {\n  list-style-type: disc;\n  padding-left: 20px;\n  text-align: left;\n  font-size: 20px;\n}\n\n.major-services-section li {\n  margin: 5px 0;\n}\n\n@media (max-width: 768px) {\n  .major-services {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .major-services-section {\n    width: 90%;\n    margin-bottom: 20px;\n  }\n\n  .major-services-section h3 {\n    margin-left: 0;\n    text-align: center;\n  }\n\n  .major-services-section ul {\n    padding-left: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
